// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RenderPopup_email_content__oVf4W {
  font-size: 18px !important;
}

.RenderPopup_email_content__oVf4W p {
  font-size: 18px !important;
}

.RenderPopup_placeholder_missing_none__nn3R- {
  display: none;
}

.RenderPopup_btn_confirm__pi54L {
  width: 200px !important;
}

.RenderPopup_btn_disabled__bYUDE {
  font-weight: bold !important;
  width: 200px;
  margin-left: 15px !important;
  color: var(--color-font-10) !important;
  background-color: gray !important;
  padding: 5px 8px !important;
  margin-top: 4px !important;
}

.RenderPopup_reminderNameInput__IcX-K {
  display: "inline-block";
  float: "left";
}

.RenderPopup_send_email_btn_disabled__8FTiV {
  height: 80px;
  width: 80px;
  background: var(--color-bg-popup-header);
  border: 1px solid #5d5d5d !important;
  display: flex;
  font-size: 18px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #707070 !important;
  margin: 0 8px 8px 0;
}

/* standard for all popups */
.RenderPopup_title__iKUwJ {
  display: flex;
}
.RenderPopup_title_icon__OkXV0 {
  margin-right: 5px;
}

.RenderPopup_btn_container__wSA0a {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.RenderPopup_send_email_btn__2JuHI {
  height: 80px;
  width: 80px;
  border: 1px solid var(--color-theme-blue) !important;
  background-color: var(--color-theme-white);
  display: flex;
  font-size: 18px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--color-theme-blue) !important;
  margin: 0 8px 8px 0;
  cursor: pointer;
}

.RenderPopup_send_icon__MLWu5 {
  margin: 10px;
}

.RenderPopup_send_icon_disabled__TnmXe {
  margin: 10px;
  color: var(--color-theme-cloud) !important;
}

.RenderPopup_emailContentContainer__SZ35h {
  padding: 10px;
  background-color: var(--color-theme-white);
  color: var(--color-font-0);
  max-height: 500px;
  overflow-y: scroll;
  font-size: 18px !important;
}

.RenderPopup_send_email_title__MBwoK {
  font-size: 18px !important;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.RenderPopup_placeholder_missing__W6goz {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 35px;
  background: var(--color-theme-red);
  font-weight: 600;
  margin-bottom: 10px;
  padding: 10px;
  box-sizing: border-box;
}

.RenderPopup_placeholder_message_icon__MZTD0 {
  color: var(--color-theme-white);
}

.RenderPopup_placeholder_message__g40ng {
  margin: 0 0 0 10px;
  color: var(--color-theme-white);
}

.RenderPopup_Mui-disabled__jWqWA {
  background-color: gray !important;
  color: white !important;
}

.RenderPopup_loading__aGNY7 {
  width: 80px;
}

.RenderPopup_reminder_container_content__yWfHL {
  float: left;
}

.RenderPopup_attachments_row__F5ttr {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}

.RenderPopup_menu_item_span__4QGWy {
  margin: 0px 0px;
}

.RenderPopup_attachment_item__ZAVd\\+ {
  margin-right: 10px;
  margin-top: 10px;
  padding: 5px;
  border: 2px solid #e7e5df;
  background-color: #edebe9;
}

.RenderPopup_attachment_delete_icon__ktQXI {
  cursor: pointer;
  margin-top: -10px;
  position: relative;
  top: 6px;
}

.RenderPopup_attachment_prefix__r3hht {
  margin-right: 10px;
  top: 4px;
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/RenderPopup/RenderPopup.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,4BAA4B;EAC5B,sCAAsC;EACtC,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,oCAAoC;EACpC,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oDAAoD;EACpD,0CAA0C;EAC1C,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB","sourcesContent":[".email_content {\n  font-size: 18px !important;\n}\n\n.email_content p {\n  font-size: 18px !important;\n}\n\n.placeholder_missing_none {\n  display: none;\n}\n\n.btn_confirm {\n  width: 200px !important;\n}\n\n.btn_disabled {\n  font-weight: bold !important;\n  width: 200px;\n  margin-left: 15px !important;\n  color: var(--color-font-10) !important;\n  background-color: gray !important;\n  padding: 5px 8px !important;\n  margin-top: 4px !important;\n}\n\n.reminderNameInput {\n  display: \"inline-block\";\n  float: \"left\";\n}\n\n.send_email_btn_disabled {\n  height: 80px;\n  width: 80px;\n  background: var(--color-bg-popup-header);\n  border: 1px solid #5d5d5d !important;\n  display: flex;\n  font-size: 18px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: #707070 !important;\n  margin: 0 8px 8px 0;\n}\n\n/* standard for all popups */\n.title {\n  display: flex;\n}\n.title_icon {\n  margin-right: 5px;\n}\n\n.btn_container {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.send_email_btn {\n  height: 80px;\n  width: 80px;\n  border: 1px solid var(--color-theme-blue) !important;\n  background-color: var(--color-theme-white);\n  display: flex;\n  font-size: 18px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: var(--color-theme-blue) !important;\n  margin: 0 8px 8px 0;\n  cursor: pointer;\n}\n\n.send_icon {\n  margin: 10px;\n}\n\n.send_icon_disabled {\n  margin: 10px;\n  color: var(--color-theme-cloud) !important;\n}\n\n.emailContentContainer {\n  padding: 10px;\n  background-color: var(--color-theme-white);\n  color: var(--color-font-0);\n  max-height: 500px;\n  overflow-y: scroll;\n  font-size: 18px !important;\n}\n\n.send_email_title {\n  font-size: 18px !important;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.placeholder_missing {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  height: 35px;\n  background: var(--color-theme-red);\n  font-weight: 600;\n  margin-bottom: 10px;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n.placeholder_message_icon {\n  color: var(--color-theme-white);\n}\n\n.placeholder_message {\n  margin: 0 0 0 10px;\n  color: var(--color-theme-white);\n}\n\n.Mui-disabled {\n  background-color: gray !important;\n  color: white !important;\n}\n\n.loading {\n  width: 80px;\n}\n\n.reminder_container_content {\n  float: left;\n}\n\n.attachments_row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.menu_item_span {\n  margin: 0px 0px;\n}\n\n.attachment_item {\n  margin-right: 10px;\n  margin-top: 10px;\n  padding: 5px;\n  border: 2px solid #e7e5df;\n  background-color: #edebe9;\n}\n\n.attachment_delete_icon {\n  cursor: pointer;\n  margin-top: -10px;\n  position: relative;\n  top: 6px;\n}\n\n.attachment_prefix {\n  margin-right: 10px;\n  top: 4px;\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"email_content": `RenderPopup_email_content__oVf4W`,
	"placeholder_missing_none": `RenderPopup_placeholder_missing_none__nn3R-`,
	"btn_confirm": `RenderPopup_btn_confirm__pi54L`,
	"btn_disabled": `RenderPopup_btn_disabled__bYUDE`,
	"reminderNameInput": `RenderPopup_reminderNameInput__IcX-K`,
	"send_email_btn_disabled": `RenderPopup_send_email_btn_disabled__8FTiV`,
	"title": `RenderPopup_title__iKUwJ`,
	"title_icon": `RenderPopup_title_icon__OkXV0`,
	"btn_container": `RenderPopup_btn_container__wSA0a`,
	"send_email_btn": `RenderPopup_send_email_btn__2JuHI`,
	"send_icon": `RenderPopup_send_icon__MLWu5`,
	"send_icon_disabled": `RenderPopup_send_icon_disabled__TnmXe`,
	"emailContentContainer": `RenderPopup_emailContentContainer__SZ35h`,
	"send_email_title": `RenderPopup_send_email_title__MBwoK`,
	"placeholder_missing": `RenderPopup_placeholder_missing__W6goz`,
	"placeholder_message_icon": `RenderPopup_placeholder_message_icon__MZTD0`,
	"placeholder_message": `RenderPopup_placeholder_message__g40ng`,
	"Mui-disabled": `RenderPopup_Mui-disabled__jWqWA`,
	"loading": `RenderPopup_loading__aGNY7`,
	"reminder_container_content": `RenderPopup_reminder_container_content__yWfHL`,
	"attachments_row": `RenderPopup_attachments_row__F5ttr`,
	"menu_item_span": `RenderPopup_menu_item_span__4QGWy`,
	"attachment_item": `RenderPopup_attachment_item__ZAVd+`,
	"attachment_delete_icon": `RenderPopup_attachment_delete_icon__ktQXI`,
	"attachment_prefix": `RenderPopup_attachment_prefix__r3hht`
};
export default ___CSS_LOADER_EXPORT___;
